<template>
    <page-loading v-if="loading"></page-loading>
    <form-container v-else>
        <step-form-heading v-if="!props.messageStandardId" :icon="faListUl">
            New Standards

            <template v-slot:description>
                Messaging standard to control the quality of your team's campaign messages.
            </template>
        </step-form-heading>

        <page-header v-else class="mb-6 lg:mb-12" data-test="message-standard-header">
            <template v-slot:subtitle>
                <a
                    :href="`/settings/teams/${teamId}#/message-standards`"
                    class="no-underline! text-sky-600! text-base font-normal"
                >
                    <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                    All Brand Standards
                </a>
            </template>

            {{ messageStandard?.name }}
        </page-header>

        <div :class="{ 'grid grid-cols-12': props.messageStandardId }">
            <page-sidebar
                v-if="props.messageStandardId"
                appearance="nested"
                :links="sidebarLinks"
                data-test="message-standard-sidebar"
            ></page-sidebar>

            <slot></slot>
        </div>
    </form-container>
</template>
<script setup>
import PageLoading from '~/components/general/PageLoading.vue';
import FormContainer from '~/components/general/FormContainer.vue';
import StepFormHeading from '~/components/general/StepFormHeading.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { computed, onMounted } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowLeft, faListUl } from '@fortawesome/pro-solid-svg-icons';
import { useMessageStandardDetails } from './useMessageStandardDetails';

const props = defineProps({
    messageStandardId: {
        type: [String, Number],
        required: false,
    },
});

const teamId = Spark.state.currentTeam.id;

const { mount, messageStandard, loading } = useMessageStandardDetails();

const sidebarLinks = computed(() => [
    { href: `/settings/teams/${teamId}/message-standards/${props.messageStandardId}`, label: 'Details' },
    {
        href: `/settings/teams/${teamId}/message-standards/${props.messageStandardId}/target-groups`,
        label: 'Target Groups',
    },
]);

onMounted(() => {
    mount(props.messageStandardId);
});
</script>
